function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Path Copy 9");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "table-header-/-select-mode",
  transform: "translate(-329.000000, -15.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Group-4-Copy-3",
  transform: "translate(209.000000, 2.000000)"
}, React.createElement("g", {
  id: "Group-5"
}, React.createElement("path", {
  d: "M121.697987,19.2827311 C121.841103,19.4223243 122.034886,19.5002104 122.23655,19.4991925 C122.427739,19.5083937 122.614134,19.4386299 122.750632,19.3067823 L126.27577,16.0358093 C126.419286,15.8958313 126.5,15.7053651 126.5,15.5066813 C126.5,15.3079976 126.419286,15.1175314 126.27577,14.9775533 L122.750632,11.7065803 C122.609097,11.5701038 122.4174,11.4956654 122.21914,11.5001953 C122.02088,11.5047252 121.832912,11.5878384 121.697987,11.7306316 C121.424761,12.0177029 121.435645,12.4668146 121.722467,12.740785 L124.684562,15.5066813 L121.722467,18.2725776 C121.435645,18.546548 121.424761,18.9956598 121.697987,19.2827311 L121.697987,19.2827311 Z",
  id: "Path-Copy-9",
  transform: "translate(124.000000, 15.500000) rotate(-270.000000) translate(-124.000000, -15.500000) "
})))));

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "8px",
    height: "5px",
    viewBox: "0 0 8 5",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down.3d2caf27.svg";
export { ForwardRef as ReactComponent };